import React from 'react';
import Button from '../../../component/ui/Button';

export default function DataNotFound({
	title,
	subtitle,
	content = '',
	descriptionTitle,
	descriptionSubTitle,
	descriptionContent,
	buttonText,
	onClick,
	disabled,
}) {
	return (
		<div className="data-not-found-container">
			<div className="fs-2 fw-bold text-dark text-center py-3">{title}</div>
			<div
				className="fs-3 fw-semibold text-center py-3"
				style={{ color: 'rgba(113, 128, 150, 1)' }}
			>
				{subtitle}
			</div>
			{content !== '' && (
				<div
					className="fs-3 fw-semibold text-center py-3"
					style={{ color: 'rgba(113, 128, 150, 1)' }}
				>
					{content}
				</div>
			)}
			<div className="d-flex justify-content-center py-4">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button={buttonText}
					disabled={disabled}
					onClick={() => onClick()}
				/>
			</div>
			<div
				className="fs-3 fw-bold text-center py-2"
				style={{ color: 'rgba(113, 128, 150, 1)' }}
			>
				{descriptionTitle}
			</div>
			<div
				className="fs-3 fw-bold text-center py-2"
				style={{ color: 'rgba(113, 128, 150, 1)' }}
			>
				{descriptionSubTitle}
			</div>
			{descriptionContent !== '' && (
				<div
					className="fs-3 fw-bold text-center"
					style={{ color: 'rgba(113, 128, 150, 1)' }}
				>
					{descriptionContent}
				</div>
			)}
		</div>
	);
}
